module.exports = __webpack_public_path__ + "img/dress.54f4672d.png";